import { DsToastRegion } from '@frontends/ds';
import { FALLBACK_LOCALE, LocaleProvider } from '@frontends/util-i18n';
import { PreferencesProvider, usePreferences } from '@frontends/util-preferences';
import { ThemeProvider } from '@frontends/util-theme-provider';
import { QueryClientProvider } from '@tanstack/react-query';
import { type ReactNode } from 'react';
import { RouterProvider } from 'react-router';
import { queryClient } from './queryClient';
import { router } from './router';

// PreferencesBridge without the language: the theme follows the client apps, the language is fixed
function DisplayPreferences({ children }: { children: ReactNode }): React.JSX.Element {
  const { themeMode, setThemeMode } = usePreferences();

  return (
    <ThemeProvider mode={themeMode} onModeChange={setThemeMode}>
      <LocaleProvider locale={FALLBACK_LOCALE}>{children}</LocaleProvider>
    </ThemeProvider>
  );
}

export function App(): React.JSX.Element {
  return (
    <PreferencesProvider persist={false}>
      <DisplayPreferences>
        <QueryClientProvider client={queryClient}>
          <RouterProvider router={router} />
          <DsToastRegion placement="top end" />
        </QueryClientProvider>
      </DisplayPreferences>
    </PreferencesProvider>
  );
}
